import $ from 'jquery';

$( '.js-search-tags-form' ).on( 'submit', function(e) {
	e.preventDefault();
} );

let delayTimer;
const initialValues = $( '.js-initial' ).html();
let changed = false;
let doingAjax = false;
let previous = '';

$( '.js-search-tags' ).on( 'change paste keyup', function() {
	const $input = $( this );

	const valThis = $input.val().toLowerCase();

	if ( previous === valThis ) {
		return;
	}

	previous = valThis;

	const $wrapper = $input.closest( '.c-highlight__body' ).find( '.c-list-links' );
	const $loader = $input.closest( '.c-highlight__body' ).find( '.js-loader' );

	if ( valThis.length < 3 ) {
		if ( changed ) {
			$wrapper.html( initialValues );
			$( $loader ).removeClass( 'is-loading' );

			changed = false;
		}

		return;
	}

	clearTimeout( delayTimer );

	delayTimer = setTimeout(
		function() {
			if ( ! doingAjax ) {
				$.ajax( {
					url: window.securelist2020Data.ajaxUrl,
					method: 'get',
					dataType: 'JSON',
					data: {
						action: 'securelist_2020_get_searched_tags',
						searchedTag: valThis,
					},
					beforeSend: function() {
						doingAjax = true;
						$wrapper.empty();
						$( $loader ).addClass( 'is-loading' );
					},
					success: function( data ) {
						data.forEach(element => {
							$wrapper.append( element );
						});

						$( $loader ).removeClass( 'is-loading' );
						doingAjax = false;
					},
					error: function() {
						$( $loader ).removeClass( 'is-loading' );
						doingAjax = false;
					}
				} );
			}

			changed = true;
		},
		300
	);
});
